import * as React from "react";
const SvgFiRrCircleN = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-n_svg__a)">
      <path
        fill="#062147"
        d="M12.04.02c-6.618 0-12 5.382-12 12s5.382 12 12 12c6.616 0 12-5.383 12-12s-5.385-12-12-12m0 22c-5.515 0-10-4.486-10-10s4.484-10 10-10c5.514 0 10 4.486 10 10s-4.487 10-10 10m5-14.75v8.639c0 1.018-.679 1.844-1.689 2.056a2.2 2.2 0 0 1-.459.05c-.837 0-1.599-.48-1.946-1.268L9.297 8.085c-.008-.018-.033-.077-.158-.054-.1.02-.1.062-.1.1v8.64a1 1 0 1 1-2 0V8.13c0-1.018.678-1.844 1.688-2.057 1.007-.21 1.997.29 2.406 1.219l3.65 8.662c.007.02.037.085.156.054.1-.021.1-.062.1-.1v-8.64a1 1 0 1 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-n_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleN;
